.wrapper {
  display: flex;
  filter: drop-shadow(0 2.87rem 3.82rem rgba(242, 103, 89, 0.2));
}

.wrapper.locked {
  filter: drop-shadow(0 1rem 2rem rgba(0, 0, 0, 0.05))
    drop-shadow(0 2.8rem 4rem rgba(108, 174, 199, 0.2));
}

.wrapper.wrapper.cancelled {
  filter: none;
}
